//import {Message} from '../../message/Message';
//import {QuizMessage} from '../../modules/Quiz/QuizMessage';
export class CHECK{
    static isJson(str : string){
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }
}
export class LANG {
    static  isArabic(text: string){
        var arabic = /[\u0600-\u06FF]/;
        return arabic.test(text); // displays true
    }
    static isGerman(text: string){
        return !this.isArabic(text);
    }
}
//export class Creator {
//    static createMessageWithMessageObject(msgObject){
//          let message;
//          switch(msgObject.type){
//              case "chat":
//                   message = new Message(msgObject);
//              break;
//              case "dictionary":
//                      message =   new Message(msgObject);
//              break;
//              case "leitner":
//                      message =   new Message(msgObject);
//              break;
//              case "artikelQuiz" :
//              case "imageQuiz" :
//              case "translationQuiz":
//                      message =   new QuizMessage(msgObject);
//                     
//              break;
//          }
//          return message;
//      }
//
//} 
export class Dom {
    static addCssClass (selectedTheme: string){
        let ionApp = document.getElementsByTagName("ion-app")[0];
        ionApp.className += " "+selectedTheme;
    }
    static removeCssClass (selectedTheme: string){
        let ionApp = document.getElementsByTagName("ion-app")[0];
        ionApp.className = ionApp.className.replace(selectedTheme,"");
    }
}

export class Time {
    
    static pad2(n: number) { return n < 10 ? '0' + n : n }
    static getTimeString(date : Date = new Date()){
//        if(!date)
//            var date = new Date();
        
        return date.getFullYear().toString()+"/" 
        + Time.pad2(date.getMonth() + 1)+"/" 
        + Time.pad2( date.getDate())+" " 
        + Time.pad2( date.getHours() )+":" 
        + Time.pad2( date.getMinutes() )+":" 
        + Time.pad2( date.getSeconds() );
        
    }
    static getToday(){
        var date = new Date();
        return date.getFullYear().toString()+"/" 
        + Time.pad2(date.getMonth() + 1)+"/" 
        + Time.pad2( date.getDate())+" " 
        + "00"+":" 
        + "00"+":" 
        + "00";
    }
    static getTodayForSqlLite(){
        var date = new Date();
        return date.getFullYear().toString()+"-" 
        + Time.pad2(date.getMonth() + 1)+"-" 
        + Time.pad2( date.getDate())+" " 
        + "23"+":" 
        + "59"+":" 
        + "59";  
    }
    static getHour(){
        var date = new Date();
        return date.getHours();
    }
    static getTodayNight(){
                var date = new Date();
        return date.getFullYear().toString()+"/" 
        + Time.pad2(date.getMonth() + 1)+"/" 
        + Time.pad2( date.getDate())+" " 
        + "24"+":" 
        + "00"+":" 
        + "00";
    }

}